import debug from 'debug';
import { generateId } from 'Global/Shared/Components/Utils/GenerateId';
import { velocityTransitions } from 'Minetilbud/Shared/Components/VelocityTransitions/VelocityTransitions';
import Behaviour from './behaviour';
import Templates from './templates';

const log = debug('Overlay');

class Overlay {
	constructor() {
		this.instanceId = generateId();
		this.mainForm = document.querySelector('#mainform');
		this.siteContainer = this.mainForm.querySelector('.site-container');

		this.enableBlurFilter = true;
		this.enableDismissOverlay = true;

		this.backgroundClickEvent = this.backgroundClickHandler.bind(this);
	}

	attachDom({ cssClass, dom }) {
		const container = document.createElement('section');
		container.setAttribute('class', `o-overlay ${cssClass !== undefined ? cssClass : ''}`);
		container.setAttribute('data-overlay', `container-${this.instanceId}`);

		dom.setAttribute('data-overlay', 'dom');
		container.appendChild(dom);

		this.mainForm.insertBefore(container, this.mainForm.firstChild);
		log('attachDom');
	}

	/**
	 * @param {Object} options
	 * @param {string} [options.cssClass]
	 * @param {string} options.template
	 */
	attachTemplate({ cssClass, template }) {
		const templates = new Templates();
		this.mainForm.insertAdjacentHTML('afterbegin', templates.container({ cssClass, instanceId: this.instanceId, template }));
	}

	/**
	 * @param {Event} event
	 */
	backgroundClickHandler(event) {
		const element = event.target.closest('[data-overlay]');

		if (element === null) return;
		if (element.getAttribute('data-overlay') !== `container-${this.instanceId}`) return;
		if (this.enableDismissOverlay === false) return;

		this.hide();
	}

	/**
	 * @param {Object} options
	 * @param {string} [options.cssClass]
	 * @param {Object} [options.dom]
	 * @param {string} [options.template]
	 */
	create({ cssClass, dom, template }) {
		if (dom !== undefined) {
			this.attachDom({ cssClass, dom });
		} else if (template !== undefined) {
			this.attachTemplate({ cssClass, template });
		} else {
			log('create() - dom & template is undefined');
		}

		this.overlay = this.mainForm.querySelector(`[data-overlay="container-${this.instanceId}"]`);
		this.eventListeners();
	}

	disableBlurFilter() {
		this.enableBlurFilter = false;
	}

	disableDismissOverlay() {
		this.enableDismissOverlay = false;
	}

	eventListeners() {
		this.overlay.addEventListener('click', this.backgroundClickEvent, false);
	}

	/**
	 * @returns {Element} The dom element for the overlay
	 */
	get() {
		return this.overlay;
	}

	/**
	 * @returns {string}
	 */
	getInstanceId() {
		return this.instanceId;
	}

	hide() {
		if (this.enableBlurFilter) {
			this.siteContainer.style.filter = '';
		}
		velocityTransitions.velocity(this.overlay, 'ShrinkOut', {
			duration: 450,
			easing: 'easeOutCubic',
			complete: () => {
				Behaviour.dispatchEvent(Behaviour.eventKeys.hide, {
					instanceId: this.instanceId
				});
			}
		});
	}

	remove() {
		try {
			this.overlay.removeEventListener('click', this.backgroundClickEvent, false);
			this.mainForm.removeChild(this.overlay);
			Behaviour.dispatchEvent(Behaviour.eventKeys.remove, {
				instanceId: this.instanceId
			});
		} catch(error) {
			log('remove() - ERROR', error);
		}
		
	}

	show() {
		log('show()', this.overlay);
		if (this.enableBlurFilter) {
			this.siteContainer.style.filter = 'blur(5px)';
		}
		velocityTransitions.velocity(this.overlay, 'ShrinkIn', {
			duration: 200,
			easing: 'easeOutCubic',
			complete: () => {
				Behaviour.dispatchEvent(Behaviour.eventKeys.show, {
					instanceId: this.instanceId
				});
			}
		});
	}

}

export default Overlay;
